/**
 * Calculates the number of minutes remaining until midnight today
 * @returns {number} Minutes until midnight
 */
export const getMinutesUntilMidnight = () => {
  const now = new Date();
  const midnight = new Date(now);
  
  // Set time to midnight (next day)
  midnight.setHours(24, 0, 0, 0);
  
  // Calculate difference in milliseconds
  const diffMs = midnight - now;
  
  // Convert to minutes and return
  return Math.ceil(diffMs / (1000 * 60));
}; 